import React, { Component } from 'react'
import { Chart } from 'chart.js/auto';
import classes from "./Graph.module.css";
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import GraphZoomControls from './GraphZoomControls.js';

Chart.register(zoomPlugin);
Chart.register(annotationPlugin);

class GraphTwoBars extends Component {
    constructor(props){
        super(props);
        this.myChart = "";
    }

    generateAnnotationsList(annotations, alertPoints, alertPointsReminder, min, alertPoints2) {
        if (this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) {
        alertPoints.forEach((e, i) => {
            let new_label = {
                type: 'label',
                color: 'red',
                position: {
                    x: 'start',
                    y: 'end'
                },
                content: (ctx) => 'Alert',
                font: {
                    size: 10
                },
                xValue: e.x,
                yValue: e.y,
                yScaleID: 'y1'
            }
            annotations["alertLabel_" + i] = new_label
        })
        }
        if (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0) {
        alertPointsReminder.forEach((e, i) => {
                let eventTime = new Date(e.x)
                eventTime.setHours(0)
                eventTime.setMinutes(0)
                eventTime.setSeconds(0)
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'crossRot',
                    radius: 8,
                    yAdjust: -6,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
            let new_label = {
                type: 'label',
                color: 'red',
                position: {
                        x: 'center',
                        y: 'end'
                },
                    content: (ctx) => '?',
                font: {
                    size: 10
                },
                    yAdjust: -3,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                yScaleID: 'y1'
            }
                annotations["alertPoints_reminder_" + i] = new_point
                annotations["alertLabel_reminder_" + i] = new_label
        })
        }
        if (this.props.alertPoints2 !== undefined && this.props.alertPoints2.length > 0) {
            alertPoints2.forEach((e, i) => {
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'start',
                        y: 'end'
                    },
                    content: (ctx) => 'Alert',
                    font: {
                        size: 10
                    },
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y'
                }
                annotations["alertLabel_" + i] = new_label
            })
        }
        return (annotations)
    }


    updateAnnotationsList(annotations, alertPoints, alertPointsReminder, min, alertPoints2) {
        alertPoints.forEach((e, i) => {
            annotations["alertLabel_" + i].xValue = e.x
            annotations["alertLabel_" + i].yValue = e.y
        })
        alertPointsReminder.forEach((e, i) => {
            let eventTime = new Date(e.x)
            eventTime.setHours(0)
            eventTime.setMinutes(0)
            eventTime.setSeconds(0)
            annotations["alertPoints_reminder_" + i].xValue = eventTime.toISOString()
            annotations["alertPoints_reminder_" + i].yValue = min
            annotations["alertLabel_reminder_" + i].xValue = eventTime.toISOString()
            annotations["alertLabel_reminder_" + i].yValue = min
        })
        alertPoints2.forEach((e, i) => {
            annotations["alertLabel_" + i].xValue = e.x
            annotations["alertLabel_" + i].yValue = e.y
        })
        return (annotations)
    }

    componentDidMount() {
        var ctx = document.getElementById(this.props.id_graph);
        if (ctx === null) {
            ctx = this.props.new_window.document.getElementById(this.props.id_graph);
        }

        var local_max_x = 0;
        var local_min_x = 0;
        var curveDrawing = [];
        var curveDrawing2 = [];
        var curveThresholdDrawing = [];  
        var curveThreshold2Drawing = [];  
        var annotations = {}

        if(this.props.curve !== undefined){
            local_max_x             = this.props.max_x;
            local_min_x             = this.props.min_x;
            curveDrawing            = this.props.curve;
            curveDrawing2           = this.props.curve2;
            curveThresholdDrawing   = this.props.threshold;
            curveThreshold2Drawing   = this.props.threshold2;
            if((this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) || (this.props.alertPoints2 !== undefined && this.props.alertPoints2.length > 0) || (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0)){
                annotations = this.generateAnnotationsList(annotations, this.props.alertPoints, this.props.alertPointsReminder, this.props.min2, this.props.alertPoints2)
            }
        }

        this.myChart = new Chart(ctx, {
            labels: ["18/09"],
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: this.props.curve_name,
                        data: curveDrawing,
                        stacked:true,
                        stack: 'Stack 0',
                        backgroundColor: this.props.curve_color,
                    },
                    {
                        label: this.props.curve2_name,
                        data: curveDrawing2,
                        backgroundColor: this.props.curve2_color,
                        stacked:true,
                        stack: 'Stack 1',
                        yAxisID: 'y1',
                    },
                    {
                        type: 'line',
                        label: this.props.threshold_name,
                        data: curveThresholdDrawing,
                        borderColor: this.props.threshold_color,
                        borderWidth: 0.5,
                        pointBackgroundColor: this.props.threshold_color,
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0,
                        yAxisID: 'y',
                    },
                    {
                        type: 'line',
                        label: this.props.threshold2_name,
                        data: curveThreshold2Drawing,
                        borderColor: this.props.threshold2_color,
                        borderWidth: 0.5,
                        pointBackgroundColor: this.props.threshold2_color,
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0,
                        yAxisID: 'y1',
                    },
                ],
            },
            options: {
                animation: false,
                plugins: {
                    title: {
                        color: 'black',
                        font : {weight: 'bold'},
                        display: this.props.title !== undefined,
                        text: this.props.title
                    },
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'x',
                            threshold: 5,
                            modifierKey: 'shift',
                        },
                        limits: {
                          x: {min: 'original', max: 'original', minRange: 3600000},
                          y: {min: 'original', max: 'original'},
                        },
                        zoom: {
                          wheel: {
                            enabled: true,
                          },
                          pinch: {
                            enabled: true
                          },
                          drag: {
                            enabled: true,
                            backgroundColor: 'rgba(40, 150, 229, 0.15)',
                            borderColor: 'rgba(40, 150, 229, 0.8)',
                            borderWidth: 1,
                            threshold: 5,
                          },
                          mode: 'x',
                        }
                    },
                    annotation: {
                        annotations
                        },
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                if (tooltipItem.dataset.label === "Usage") {                                    
                                    var mins = ((parseFloat(tooltipItem.formattedValue.replace(',', '.')).toFixed(2) + "").split(".")[1]);
                                        mins = mins / 100 * 60
                                        mins = mins.toFixed(0)
                                        if (mins.toString().length === 1) {
                                            mins = mins + "0";
                                        }
                                    let ret = tooltipItem.dataset.label + ": " + parseFloat(tooltipItem.formattedValue).toFixed(0) + "h" + mins + "m"
                                    if (tooltipItem.dataIndex !== 0) {
                                        if (tooltipItem.dataset.data[tooltipItem.dataIndex - 1].y !== tooltipItem.dataset.data[tooltipItem.dataIndex].y) {
                                            // Display the data variation
                                            let diff = (parseFloat(tooltipItem.dataset.data[tooltipItem.dataIndex].y) - parseFloat(tooltipItem.dataset.data[tooltipItem.dataIndex - 1].y)).toFixed(2);
                                        var hours = ((diff + "").split(".")[0]);
                                        var mins = ((diff + "").split(".")[1]);
                                        mins = mins / 100 * 60
                                        mins = mins.toFixed(0)
                                        if (mins.toString().length === 1) {
                                            mins = mins + "0";
                                        }
                                        diff = hours + "h" + mins + "m"
                                            if (tooltipItem.dataset.data[tooltipItem.dataIndex - 1].y < tooltipItem.dataset.data[tooltipItem.dataIndex].y) {
                                            diff = '+' + diff
                                        }
                                            ret += ' (' + diff + ')'
                                    }
                                }
                                    return ret;
                                }
                                else {
                                    return tooltipItem.yLabel;
                                }
                            }
                        },
                        backgroundColor:'rgba(0,0,0,0.8)',  // black with transparency
                    },
                    legend: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        min: local_min_x,
                        max: local_max_x,
                        time: {
                            displayFormats: {
                                day: 'DD/MM',
                                month: 'DD/MM',
                            },
                            unit: 'day',
                            tooltipFormat: 'DD/MM'
                        },
                        ticks: {
                          minRotation: 0,
                          maxRotation: 0,
                          major: {
                            enabled: true
                          },
                          font: function(context) {
                            if (context.tick && context.tick.major) {
                              return {
                                weight: 'bold',
                              };
                            }
                          }
                        }
                    },
                    y: {
                        stacked:true,
                        min: this.props.min,
                        max: this.props.max,
                        title: {
                            display: this.props.y_axis_title !== undefined,
                            text: this.props.y_axis_title,
                            color: this.props.curve_color                            
                        },
                        grid: {
                          drawOnChartArea: false,
                        },
                        ticks: {
                          color: this.props.curve_color, 
                          stepSize: 5
                        },
                    },
                    y1: {
                        stacked:true,
                        min: this.props.min2,
                        max: this.props.max2,
                        title: {
                            display: this.props.y_axis_title2 !== undefined,
                            padding: 0,
                            text: this.props.y_axis_title2,
                            color: this.props.curve2_color                            
                        },
                        position: 'right',
                        major: {
                            enabled: false
                        },
                        grid: {
                            color: (ctx) => (ctx.tick.value === 0 ? 'rgba(0, 0, 0, 0.1)' : 'transparent')
                        },
                        ticks: {
                          color: this.props.curve2_color, 
                          stepSize: 5
                        },
                    }
                },
            }
        });
    }

    updateData() {

        if((this.myChart !== undefined)&&(this.myChart.data !== undefined)){
            // Skip refresh while zoomed/panned so the periodic update does not
            // snap the view back to the full range. Resumes on reset.
            if(this.myChart.isZoomedOrPanned && this.myChart.isZoomedOrPanned()){ return; }
            this.myChart.options.scales.x.max  = this.props.max_x;
            this.myChart.options.scales.x.min  = this.props.min_x;
            this.myChart.data.datasets[0].data = this.props.curve;
            this.myChart.data.datasets[1].data = this.props.curve2;
            this.myChart.data.datasets[2].data = this.props.threshold;
            this.myChart.data.datasets[3].data = this.props.threshold2;
            if(this.props.alertPoints !== undefined || this.props.alertPoints2 !== undefined || this.props.alertPointsReminder !== undefined ){
                this.myChart.options.plugins.annotation.annotations = this.updateAnnotationsList(this.myChart.options.plugins.annotation.annotations, this.props.alertPoints, this.props.alertPointsReminder, this.props.min2, this.props.alertPoints2)
            }  
            this.myChart.update();
        }
    }

    render() {
        return (
            <div className={classes.graphContainer} style={{display: "flex", flexDirection: "column", height: "100%", width: "100%"}}>
                <div style={{flex: "1 1 auto", minHeight: 0, width: "100%", display: "flex", justifyContent:'center', alignItems:'center'}}>
                    <canvas
                        style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
                        id={this.props.id_graph}
                        ref={this.chartRef}
                    />
                </div>
                <GraphZoomControls
                    getChart={() => this.myChart}
                    onEnlarge={this.props.onEnlarge}
                />
                {
                    this.updateData()
                }
            </div>
        )
    }
}
export default (GraphTwoBars)
